<template>
  <chart-container :title="title">
    <div class="pl-2">
      <div class="subtitle-1 text-capitalize font-weight-medium category-entry">
        {{ options.categoryName }}
      </div>
      <div class="d-flex justify-center">
        <div
          v-for="category in options.categories"
          :key="category.text"
          class="percentage-block white-text tooltip"
          :style="{
            'background-color': category.color,
            width: `${getCategoryWeight(category).toFixed(0)}%`,
          }"
        >
          <span class="tooltiptext"
            >{{ category.text }}
            {{ getCategoryWeight(category).toFixed(1) }}%</span
          >
          {{
            getCategoryWeight(category) > 6
              ? `${getCategoryWeight(category).toFixed(1)}%`
              : "&#8203;"
          }}
        </div>
      </div>
    </div>
    <div
      class="mt-2"
      :style="{
        'overflow-y': 'scroll',
        height: `${height}px`,
      }"
    >
      <div
        v-for="category in options.categories"
        :key="category.text"
        class="pb-2 px-2"
      >
        <div
          class="subtitle-1 text-capitalize font-weight-medium category-entry"
          @click="onCategoryClick(category)"
          style="cursor: pointer"
        >
          {{ category.text }}
        </div>
        <div
          v-for="(topic, index) in category.topics"
          :key="index"
          @click="onTopicClick(topic)"
          style="cursor: pointer"
          class="topic-entry px-1 px-md-2"
        >
          <div class="d-flex justify-space-between">
            <span>{{ topic.text }}</span>
            <span>{{ topic.count }}</span>
          </div>
          <div
            :style="{
              'background-color': category.color,
              height: '3px',
              width: `${getTopicWeight(category, topic)}%`,
            }"
          ></div>
        </div>
      </div>
    </div>
  </chart-container>
</template>

<script>
import _maxby from "lodash.maxby";
import _sumby from "lodash.sumby";
import ChartContainer from "@/components/dashboard/ChartContainer.vue";
export default {
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: false,
    },
  },
  components: {
    ChartContainer,
  },
  methods: {
    getCategoryWeight(category) {
      return (category.count / this.getGrandTotal) * 102;
    },
    getTopicWeight(category, topic) {
      return (topic.count / this.getMaxPerCategory[category.key]) * 90;
    },
    onCategoryClick(category) {
      console.log("onCategoryClick", category);
      this.$emit("filter", [
        {
          source: "chart",
          title: "Categorias",
          ...category,
        },
      ]);
    },
    onTopicClick(topic) {
      console.log("onTopicClick", topic);
      this.$emit("filter", [
        {
          source: "chart",
          title: "Topics",
          ...topic,
        },
      ]);
    },
  },
  computed: {
    getMaxPerCategory() {
      let maxCounts = {};
      this.options.categories.forEach((category) => {
        maxCounts[category.key] = _maxby(category.topics, (o) => o.count).count;
      });
      return maxCounts;
    },
    getGrandTotal() {
      return _sumby(this.options.categories, (o) => o.count);
    },
  },
};
</script>

<style scoped>
.percentage-block {
  display: inline-block;
  text-align: center;
  height: 20px;
  border: none;
  margin-right: -4px;
  color: #f3f3f4;
}
.category-entry:hover,
.topic-entry:hover {
  background-color: #f6f6f6;
}

/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
</style>